import { gsap, Power3 } from "gsap";

export default class ExpandList {
    constructor() {
        this.lists = document.querySelectorAll('.js-expand-list');

        if (this.lists) {
            this.init();
        }
    }

    init() {

        this.lists.forEach(element => {
            if (element.querySelector('.js-expand-list-trigger')) {
                element.querySelector('.js-expand-list-trigger').addEventListener("click", (e) => {
                    this.expand(element.querySelector('.js-expand-list-trigger'), element.querySelector('.js-expand-list-content'));
                });
            }
            if (element.querySelector('.js-expand-list-trigger')) {
                element.querySelector('.js-expand-list-trigger').addEventListener("keydown", (e) => {
                    if (e.code === "Enter") {
                        this.expand(element.querySelector('.js-expand-list-trigger'), element.querySelector('.js-expand-list-content'));
                    }
                });
            }
        });

    }
    expand(trigger, items) {
        gsap.to(items, {
            duration: .25,
            delay: .25,
            height: 'auto',
            ease: Power3.in
        });
        gsap.to(trigger, {
            duration: .25,
            opacity: '0',
            display: 'none',
            ease: Power3.in
        });
    }

}
